import * as React from "react";
// Remember that all const are suffix _svg

const star_svg = (
  <svg
    className={"star_svg icon_svg"}
    xmlns="http://www.w3.org/2000/svg"
    width="72.531"
    height="72.531"
    viewBox="0 0 72.531 72.531"
  >
    <path
      id="Path_50"
      data-name="Path 50"
      d="M36.267,0,29.633,11.521,18.127,4.856l.029,13.3-13.3-.03,6.665,11.506L0,36.266,11.522,42.9,4.856,54.4l13.3-.029-.03,13.3L29.632,61.01l6.634,11.521L42.9,61.01,54.4,67.676l-.03-13.3,13.3.03L61.009,42.9l11.522-6.634-11.52-6.635,6.665-11.5-13.3.029.03-13.3L42.9,11.521Z"
      transform="translate(0 0)"
      fill="#bb5148"
    />
  </svg>
);

const point_svg = (
  <svg className={"point_svg icon_svg"} xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
    <g id="Group_53" data-name="Group 53" transform="translate(-104 -3217)">
      <circle
        id="Ellipse_1"
        data-name="Ellipse 1"
        cx="12.5"
        cy="12.5"
        r="12.5"
        transform="translate(104 3217)"
        fill="#bb5148"
      />
    </g>
  </svg>
);
const mobile_svg = (
  <svg
    className={"mobile_svg icon_svg"}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M2.64794 1.98511L3.4226 1.21045C3.9159 0.717154 4.71568 0.717155 5.20898 1.21045L8.47523 4.4767C8.96853 4.97 8.96853 5.76978 8.47523 6.26308L6.21113 8.52718C5.8336 8.90471 5.74 9.48148 5.97878 9.95903C7.3591 12.7197 9.59758 14.9582 12.3582 16.3385C12.8358 16.5773 13.4125 16.4837 13.7901 16.1061L16.0542 13.842C16.5475 13.3487 17.3473 13.3487 17.8406 13.842L21.1068 17.1083C21.6001 17.6016 21.6001 18.4014 21.1068 18.8947L20.3322 19.6693C17.6652 22.3363 13.443 22.6364 10.4257 20.3734L8.89925 19.2285C6.69689 17.5768 4.74049 15.6204 3.08872 13.418L1.94391 11.8916C-0.319088 8.87427 -0.0190259 4.65208 2.64794 1.98511Z"
      fill="white"
    />
  </svg>
);
const email_svg = (
  <svg className={"email_svg icon_svg"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7 .3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2 .4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z" />
  </svg>
);

const location_svg = (
  <svg
    className={"location_svg icon_svg"}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="23"
    viewBox="0 0 22 23"
    fill="none"
  >
    <path d="M9.16667 9.61195C9.16667 10.6386 9.98748 11.4709 11 11.4709C12.0125 11.4709 12.8333 10.6386 12.8333 9.61195C12.8333 8.58529 12.0125 7.75301 11 7.75301C9.98748 7.75301 9.16667 8.58529 9.16667 9.61195Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.66237 21.9888C7.00961 20.6174 1.24432 17.0468 0.160481 11.4709C-0.742857 6.82354 2.07366 0.317261 11 0.317261C19.9264 0.317261 22.7428 6.82354 21.8395 11.4709C20.7557 17.0468 14.9904 20.6174 12.3376 21.9888C11.4906 22.4267 10.5094 22.4267 9.66237 21.9888ZM7.33333 9.61195C7.33333 11.6653 8.97496 13.3298 11 13.3298C13.025 13.3298 14.6667 11.6653 14.6667 9.61195C14.6667 7.55862 13.025 5.89407 11 5.89407C8.97496 5.89407 7.33333 7.55862 7.33333 9.61195Z"
    />
  </svg>
);
const calendar_svg = (
  <svg
    className={"calendar_svg icon_svg"}
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
  >
    <path
      d="M0.630493 8.0343C0.630493 5.96028 0.630493 4.92327 1.27478 4.27893C1.27482 4.27889 1.27486 4.27885 1.27491 4.27881C1.91924 3.63452 2.95625 3.63452 5.03027 3.63452H18.2307C20.3047 3.63452 21.3417 3.63452 21.9861 4.27881C21.9861 4.27885 21.9862 4.27889 21.9862 4.27893C22.6305 4.92327 22.6305 5.96028 22.6305 8.0343C22.6305 8.5528 22.6305 8.81205 22.4694 8.97314C22.4694 8.97315 22.4694 8.97316 22.4694 8.97317C22.3083 9.13424 22.0491 9.13424 21.5306 9.13424H1.73044C1.21193 9.13424 0.952681 9.13424 0.791596 8.97317C0.791586 8.97316 0.791575 8.97315 0.791564 8.97314C0.630493 8.81205 0.630493 8.5528 0.630493 8.0343Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.27484 21.6935C0.630493 21.0491 0.630493 20.0121 0.630493 17.9379V12.4384C0.630493 11.9198 0.630493 11.6606 0.79158 11.4995C0.952667 11.3384 1.21193 11.3384 1.73046 11.3384H21.5305C22.0491 11.3384 22.3083 11.3384 22.4694 11.4995C22.6305 11.6606 22.6305 11.9198 22.6305 12.4384V17.9379C22.6305 20.0121 22.6305 21.0491 21.9861 21.6935C21.3418 22.3378 20.3047 22.3378 18.2306 22.3378H5.03038C2.95625 22.3378 1.91919 22.3378 1.27484 21.6935ZM7.22424 15.7379C6.61675 15.7379 6.12427 16.2304 6.12427 16.8379C6.12427 17.4454 6.61675 17.9379 7.22424 17.9379H16.0242C16.6317 17.9379 17.1242 17.4454 17.1242 16.8379C17.1242 16.2304 16.6317 15.7379 16.0242 15.7379H7.22424Z"
      fill="white"
    />
    <path d="M6.13049 1.43384L6.13049 4.73367" stroke="white" strokeWidth="2.19994" strokeLinecap="round" />
    <path d="M17.1305 1.43384L17.1305 4.73367" stroke="white" strokeWidth="2.19994" strokeLinecap="round" />
  </svg>
);

const whatsapp_svg = (
  <svg
    className={"whatsapp_svg icon_svg"}
    aria-hidden="true"
    focusable="false"
    data-prefix="fab"
    data-icon="whatsapp"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
  >
    <path
      fill="#FFF"
      d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
    ></path>
  </svg>
);

export { calendar_svg, email_svg, location_svg, mobile_svg, point_svg, star_svg, whatsapp_svg };
